import axios, { AxiosResponse } from 'axios';

export function getPlatformBaseURL(): string {
  return process.env.NEXT_PUBLIC_API_URI || '';
}

type TPlatformFetchParams = {
  method: 'GET' | 'POST' | 'PATCH' | 'DELETE';
  path: string;
  headers?: Record<string, any>;
  data?: any;
};

function platformFetch<T = any>({
  method,
  path,
  headers,
  data,
}: TPlatformFetchParams): Promise<AxiosResponse<T>> {
  return axios({
    method,
    url: `${getPlatformBaseURL()}${path}`,
    headers,
    data,
  });
}

export default platformFetch;
